/**
 * The Insights page's top bar (components/site-analytics/insights-header.blade.php, S32): its height,
 * measured whenever it changes (it wraps onto more rows as the page narrows), as
 * --insights-header-height on the document element. Stats' filter header and arranging bar pin
 * under the bar by it, and the page's scroll margins clear it, so nothing scrolled into view or
 * focused lands under the bar (WCAG 2.4.11). On the document element, as the arranging bar's height
 * is, since each Livewire render puts back a component root's own attributes.
 */
export const TOP_BAR_HEIGHT = "--insights-header-height";

export default function InsightsTopBar() {
    // Kept out of the component's reactive state: an observer wrapped in Alpine's proxy would be
    // called on the proxy, which the browser refuses.
    let observer = null;

    return {
        init() {
            const measure = () => document.documentElement.style.setProperty(TOP_BAR_HEIGHT, `${this.$el.offsetHeight}px`);

            measure();

            if (typeof ResizeObserver === "function") {
                observer = new ResizeObserver(measure);
                observer.observe(this.$el);
            }
        },

        destroy() {
            observer?.disconnect();
            document.documentElement.style.removeProperty(TOP_BAR_HEIGHT);
        },
    };
}
